<template>
  <div>
    <!-- 卡片试图 -->
    <el-card class="box-card" v-loading="loading">
      <!-- 搜索与添加区域 -->
      <el-row :gutter="35">
        <el-col :span="7">
          <el-input :placeholder="$t('clientmanage.addDialog.placeholdertext')" clearable v-model="adminQuery.userName"
            @clear="searchClear()">
            <el-button slot="append" icon="el-icon-search" @click="getUserList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" class="search" @click="addUserDialogVisible = true">
            {{ $t("accountmanager.addUser") }}
          </el-button>

          <el-button size="mini" type="primary" @click="handleAccountExport(exportParam)">
            {{ $t('btns.export') }}
          </el-button>
        </el-col>
      </el-row>

      <!-- 用户列表区域 -->
      <el-table :data="UserList" stripe class="table" :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column :label="$t('accountmanager.userName')" prop="userName"></el-table-column>
        <el-table-column :label="$t('accountmanager.email')" prop="userEmail"></el-table-column>
        <el-table-column :label="$t('accountmanager.userPhone')" prop="userPhone"></el-table-column>
        <el-table-column :label="$t('accountmanager.roleName')" prop="roleName"></el-table-column>
        <el-table-column :label="$t('accountmanager.userType')" prop="userType">
          <template slot-scope="scope">
            <div v-if="scope.row.userType == 0">{{ $t("accountmanager.Administrator") }}</div>
            <div v-if="scope.row.userType == 1">{{ $t("accountmanager.Agency") }}</div>
            <div v-if="scope.row.userType == 2">{{ $t("accountmanager.Commercial") }}</div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('accountmanager.createAcct')" prop="createAcct"></el-table-column>
        <el-table-column :label="$t('accountmanager.createTime')" prop="createTime"></el-table-column>
        <el-table-column width="140px" :label="$t('accountmanager.makeupAmountLimit')" prop="makeupAmountLimit">
          <template slot-scope="scope">
            {{ scope.row.makeupAmountLimit | toThousands }}
            <br />

            <el-popconfirm
              :ref="`modiFicaTion-${scope.row.id}-1`"
              :key="`modiFicaTion-${scope.row.id}-1`"
              :title="$t('orders.tip.danger')"
              @confirm="changAmountLimit(scope.row, getUserList)"
              v-if="permission.indexOf('admin:updateMakeupLimit') != -1"
            >
              <el-button slot="reference" type="primary" size="mini">
                {{ $t('rolemanager.modiFicaTion') }}
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
        <el-table-column :label="$t('accountmanager.userState')">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.acctStatus" :active-value="0" :inactive-value="1" class="demo"
              active-color="#00A854" :disabled="state" inactive-color="#F56C6C"
              @change="switchStatus(scope.row.id)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column :label="$t('accountmanager.operation')" width="200">
          <template slot-scope="scope">
            <!-- 修改 -->
            <el-tooltip effect="dark" :content="$t('btns.editor')" placement="top" :enterable="true" :key="`${scope.row.id}-1`">
              <el-popconfirm :ref="`popover-${scope.row.id}-1`"
                :title="$t('orders.tip.danger')" @confirm="changpassword(scope.row)">
                <el-button slot="reference" type="primary" icon="el-icon-edit" circle></el-button>
              </el-popconfirm>
            </el-tooltip>
            <!-- 重置密码 -->
            <el-tooltip effect="dark" :content="$t('accountmanager.resetSignPass')" placement="top" :enterable="true" :key="`${scope.row.id}-2`">
              <el-popconfirm :ref="`popover-${scope.row.id}-2`"
                :title="$t('orders.tip.danger')" @confirm="resetPwd(scope.row)">
                <el-button slot="reference" type="warning" icon="el-icon-setting" circle></el-button>
              </el-popconfirm>
            </el-tooltip>
            <!-- <el-tooltip effect="dark" :content="$t('clientmanage.addDialog.googleQrCode')" placement="top" :key="`${scope.row.id}-3`"
              :enterable="true">
              <el-popconfirm :ref="`popover-${scope.row.id}-3`"
                :title="$t('orders.tip.danger')" @confirm="showKeysInfo(scope.row)">
                <el-button slot="reference" type="success" icon="el-icon-document-checked" size="medium"
                  circle></el-button>
              </el-popconfirm>
            </el-tooltip> -->
            <el-tooltip effect="dark" :content="$t('clientmanage.addDialog.unlock')" placement="top" :key="`${scope.row.id}-3`"
             >
              <el-popconfirm :ref="`popover-${scope.row.id}-3`"
                :title="$t('orders.tip.danger')" @confirm="unlock(scope.row)">
                <el-button slot="reference" type="success" icon="el-icon-unlock" size="medium"
                  circle></el-button>
              </el-popconfirm>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('clientmanage.addDialog.resetGoogleCode')" placement="top" :key="`${scope.row.id}-4`"
              :enterable="true">
              <el-popconfirm :ref="`popover-${scope.row.id}-4`"
                :title="$t('orders.tip.danger')" @confirm="resetGoogleKey(scope.row)">
                <el-button slot="reference" type="success" icon="el-icon-refresh" size="medium" circle></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <v-pagination v-model="adminQuery" :total="total" @update="getUserList" />

      <!-- 添加用户的对话框 -->
      <el-dialog :title="$t('accountmanager.addUser')" :visible.sync="addUserDialogVisible" width="50%"
        @close="addUserDialogClose">
        <!-- 内容主体区域 -->
        <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px" v-loading="addUserLoading">
          <el-form-item :label="$t('accountmanager.userName')" prop="userName">
            <el-input v-model="addForm.userName"></el-input>
          </el-form-item>

          <el-form-item :label="$t('accountmanager.userPass')" prop="userPass">
            <el-input show-password v-model="addForm.userPass"></el-input>
          </el-form-item>

          <el-form-item :label="$t('rolemanager.roleId')" prop="roleId">
            <template>
              <el-select v-model="addForm.roleId" :placeholder="$t('rolemanager.selectroleId')">
                <!-- 添加角色的下拉列 -->
                <el-option v-for="(item, index) in this.rolestorage" :key="index" :label="item.roleName"
                  :value="item.id"></el-option>
                <el-option :label="$t('btns.emptyValue')" value=""></el-option>
              </el-select>
            </template>
          </el-form-item>

          <el-form-item :label="$t('accountmanager.userState')">
            <template>
              <el-switch v-model="addForm.acctStatus" :active-value="0" :inactive-value="1"
                active-color="#00A854" :active-text="$t('accountmanager.active')" :disabled="state"
                inactive-color="#F56C6C" :inactive-text="$t('accountmanager.inactive')"></el-switch>
            </template>
          </el-form-item>
        </el-form>
        <!-- 底部区域 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="addUserDialogVisible = false">
            {{ $t("accountmanager.cancel") }}
          </el-button>
          <el-button type="primary" @click="addUser">{{ $t("accountmanager.confirm") }}</el-button>
        </span>
      </el-dialog>

      <!-- 修改密码的对话框 -->
      <el-dialog :title="$t('accountmanager.changePass')" :visible.sync="changeDialogVisible" width="50%"
        @close="editDialogClose">
        <!-- 内容主体区域 -->
        <el-form :model="changePass" :rules="addFormRules" ref="changpassRef" label-width="70px"
          v-loading="alterPassword">
          <el-form-item :label="$t('accountmanager.roleName')" prop="roleId">
            <el-select v-model="changePass.roleId">
              <el-option v-for="item in rolestorage" :key="item.id" :value="item.id" :label="item.roleName"></el-option>
              <el-option :label="$t('btns.emptyValue')" value=""></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('accountmanager.oblPass')" prop="userPassModify">
            <el-input show-password v-model="changePass.userPassModify" auto-complete="false"></el-input>
          </el-form-item>
          <el-form-item :label="$t('accountmanager.newPass')" prop="newPasswordModify">
            <el-input show-password v-model="changePass.newPasswordModify" auto-complete="false"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="changeDialogVisible = false">
            {{ $t("accountmanager.cancel") }}
          </el-button>
          <el-button type="primary" @click="changepwdInfo">
            {{ $t("accountmanager.confirm") }}
          </el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="showKeysInfoFlag" :close-on-click-modal="false" width="400px">
        <el-row>
          <img :src="secretQr" alt style="margin-left: 30px;" />
        </el-row>
      </el-dialog>
    </el-card>
    <QrCodeModal ref="qrCodeModal"/>
  </div>
</template>

<script>
  import { validEmail,checkNewPass} from "@/utils/validate";
  import merchantApi from "@/api/merchant";
  import { mapGetters } from "vuex";
  import base from '@/mixin/base.js';
  import QrCodeModal from '@/components/qrCodeModa';
  export default {
    mixins: [base],
    name: "accountmanager",
    components: {
      QrCodeModal
    },
    data() {
      // 验证用户名的规则
      var checkName = (rule, value, cb) => {
        const regName = /^[0-9a-zA-Z]{4,20}$/;
        if (regName.test(value)) {
          return cb();
        }
        cb(new Error(this.$t("accountmanager.checkNameErr")));
      };
      // 验证密码的规则
      var checkPassModify = (rule, value, cb) => {
        const regPass = /^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/;
        if (!value || regPass.test(value)) {
          return cb();
        }
        cb(new Error(this.$t("accountmanager.checkPassErr")));
      };
     
      // 验证邮箱的规则
      var vaildataEmail = (rule, value, cb) => {
        if (validEmail(value)) {
          return cb();
        }
        cb(new Error(this.$t("accountmanager.checkEmailErr")));
      };
      // 验证手机号
      var vaildataPhone = (rule, value, cb) => {
        const phoneNumber = /^0?[3,5,7,8,9]{1}[0-9]{8}$/;
        if (phoneNumber.test(value)) {
          return cb();
        }
        cb(new Error(this.$t("accountmanager.checkPhoneErr")));
      };

      return {
        exportParam:{
          api:merchantApi.exportAdminAccount,
          formatParams:{}
        },
        showKeysInfoFlag: false,
        secretQr: "",
        UserList: [], //用户列表
        total: 0,
        addUserDialogVisible: false, //控制添加用户对话框的显示 隐藏
        changeDialogVisible: false, //控制修改密码对话框
        addForm: {
          //添加用户的表单数据
          id: "",
          roleId: "",
          roleName: "",
          userName: "",
          userPass: "",
          userType: 0
        },
        adminQuery: {
          userName: "",
          size: this.$defaultPaginationSize,
          no: 1
        },
        // 添加账号的验证规则对象
        addFormRules: {
          userName: [
            {
              required: true,
              message: this.$t("accountmanager.addFormName"),
              trigger: "blur"
            },
            {
              validator: checkName,
              trigger: "blur"
            }
          ],
          userPass: [
            //原密码
            {
              required: true,
              message: this.$t("accountmanager.addFormPass"),
              trigger: "blur"
            },
            {
              validator: (rules, value, cb) => {
                  if (!checkNewPass(value)) {
                    cb(new Error(this.$t('passwd.rules.newPasswd.format')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
          ],
          userPassModify: [
            //原密码
            {
              required: false,
              message: this.$t("accountmanager.addFormPass"),
              trigger: "blur"
            },
            // {
            //   validator: checkPassModify,
            //   trigger: "blur"
            // }
          ],
          newPasswordModify: [
            //新密码
            {
              required: true,
              message: this.$t("accountmanager.addFormPass"),
              trigger: "blur"
            },
            {
              validator: (rules, value, cb) => {
                  if (!checkNewPass(value)) {
                    cb(new Error(this.$t('passwd.rules.newPasswd.format')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
          ],
          userPhone: [
            {
              required: true,
              message: this.$t("accountmanager.addFormPhone"),
              trigger: "blur"
            },
            {
              validator: vaildataPhone,
              trigger: "blur"
            }
          ],
          userEmail: [
            {
              required: true,
              message: this.$t("accountmanager.addFormEmail"),
              trigger: "blur"
            },
            {
              validator: vaildataEmail,
              trigger: "blur"
            }
          ]
        },
        userId: null,
        state: false,
        // 修改密码的参数对象
        changePass: {
          id: "",
          roleId: "",
          newPassword: "",
          newPasswordModify: "",
          userPass: "",
          userPassModify: ""
        },
        rolestorage: [],
        loading: false, //整页loading
        alterPassword: false,
        addUserLoading: false
      };
    },
    computed: {
          ...mapGetters(["permission"])
      },
    created() {
      this.getUserList();
      this.roleList();
    },
    methods: {
      // 获取用户列表
      async getUserList() {
        this.loading = true;
        const res = await this.$http.post("/admin/list/page",
          { query: { userName: this.adminQuery.userName }, no: this.adminQuery.current, size: this.adminQuery.size }
        );
        if (res.data.code == 200) {
          this.total = res.data.data.rows;
          this.UserList = res.data.data.list;
        } else {
          this.$message.error(res.data.msg);
        }
        this.loading = false;
      },
      // 获取角色列表，为新增账号绑定角色
      async roleList() {
        let res = await this.$http.post("/role/list/page", {
          size:999,
          no:1,
          query: {

          } });
        this.rolestorage = res.data.data.list;
      },
      // 点击添加新用户
      addUser() {
        this.$refs.addFormRef.validate(async (valid) => {
          if (!valid) return this.$message.error(this.$t("accountmanager.refError"));
          // 发起添加用户的请求
          this.addUserLoading = true;
          const res = await this.$http.post("/admin/add", this.addForm);
          this.addUserLoading = false;
          this.$refs.qrCodeModal.showModal(res.data.data);
          if (res.data.code != 200) return this.$message.error(res.data.msg);
          this.addUserDialogVisible = false;
          this.getUserList();
          return this.$message.success(res.data.msg);
        });
      },
      // 监听页码值改变的事件
      pagcurrentAdd(newPage) {
        this.adminQuery.current = newPage;
        this.getUserList();
      },
      // 监听 pagesize 改变的事件
      pagsizeAdd(newSize) {
        this.adminQuery.size = newSize;
        this.getUserList();
      },
      // 监听添加用户对话框的关闭事件
      addUserDialogClose() {
        this.addForm = {
          //添加用户的表单数据
          id: "",
          roleId: "",
          roleName: "",
          userName: "",
          userPass: "",
          userType: 0
        };
      },
      // 监听修改用户对话框的关闭事件
      editDialogClose() {
        this.changePass = {
          id: "",
          roleId: "",
          newPassword: "",
          userPass: ""
        };
      },
      // 清空搜索框
      searchClear() {
        this.adminQuery.userName = "";
        this.getUserList();
      },
      // 更新账号状态
      async switchStatus(id) {
        console.log(id);
        this.loading = true;
        const res = await this.$http.get("/admin/switchStatus?userId=" + id);
        this.loading = false;
        console.log(res);
        //未完成
      },
      // 获取id
      changpassword(row) {
        this.alterPassword = true;
        this.changeDialogVisible = true;
        this.$nextTick(() => {
          this.changePass.id = row.id;
          this.changePass.roleId = row.roleId;
          this.alterPassword = false;
        });
      },
      // 点击发起修改密码的请求
      async changepwdInfo() {
        this.$refs.changpassRef.validate(async (valid) => {
          if (!valid || (this.changePass.userPass.length != 0 && this.changePass.newPassword.length != 0 && this.changePass.userPass == this.changePass.newPassword))
            return this.$message.error(this.$t("accountmanager.changerefError"));
          this.alterPassword = true;
          const { data } = await this.$http.post("/admin/updatePassword", {
            id: this.changePass.id,
            roleId: this.changePass.roleId,
            oldPassword: this.changePass.userPassModify,
            newPassword: this.changePass.newPasswordModify
          });
          if (data && data.code == 200) {
            this.getUserList();
          } else {
            this.$message.error(data.msg);
          }
          this.alterPassword = false;
          this.changeDialogVisible = false;
        });
      },
      // 重置密码
      async resetPwd(row) {
        // 弹框询问用户是否重置密码
        const confirmResult = await this.$confirm(
          this.$t("accountmanager.hintmessage"),
          this.$t("btns.hint"),

          {
            confirmButtonText: this.$t("btns.confirm"),
            cancelButtonText: this.$t("btns.cancel"),
            type: "warning"
          }
        ).catch((err) => err);
        // 用户确认删除 返回值为字符串 confirm
        // 用户取消删除 返回值为字符串 cancel
        if (confirmResult !== "confirm") {
          return this.$message.info(this.$t("btns.cancel"));
        }
        this.loading = true;
        const res = await this.$http.get("/admin/restPassword?userId=" + row.id);
        this.loading = false;
        if (res.data.code != 200) {
          return this.$message.error(this.$t("btns.error"));
        }
        this.$message.success(this.$t("btns.success"));
        // 刷新数据列表
        this.getUserList();
      },
      async showKeysInfo(row) {
       const Code = await this.promptGoogleCode();
        if (!Code) return;
        let datas = "userName=" + row.userName +  "&googleCode=" +  Code.value
        const { data } = await merchantApi.getGoogleQrCode(datas);
        if (data && data.code == 200) {
          this.secretQr = data.data.secretQr;
          this.showKeysInfoFlag = true;
        } else {
          this.$message.error(this.$t("status.error"));
        }
      },
      //   重置谷歌密钥
      async resetGoogleKey(row) {
         const Code = await this.promptGoogleCode();
        if (!Code) return;
        const { data } = await merchantApi.resetGoogleCodeKey({ merchantId: row.userName ,googleCode:Code.value });
        if (data && data.code == 200) {
          this.$message.success(data.msg);
          this.getUserList();
          this.$refs.qrCodeModal.showModal(data.data);
        } else {
          this.$message.error(this.$t('status.error'));
        }
      },
      async unlock(row) {
        const Code = await this.promptGoogleCode();
        if (!Code) return;
        const { data } = await merchantApi.userUnlock({ userName: row.userName ,googleCode:Code.value });
        if (data && data.code == 200) {
          this.$message.success(data.msg);
        }
      }
    }
  };
</script>

<style scoped>
  .box-card,
  .table,
  .pag {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/accountmanager/index.vue